module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/chevron-square-down.svg?a4927e243c270b7517b6196bba938f87";